module.exports = __webpack_public_path__ + "img/8.f71d6d21.svg";